import { theme } from '@codametrix/ui-common';
export const styles = ()=>({
        text: {
            ...theme.textStyles['h4'],
            color: theme.colors.text['highEmphasis']
        }
    });
